module.exports = __webpack_public_path__ + "static/media/tracy_02.7369b778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_02.jpg
// module id = 380
// module chunks = 0